import React, { Component } from 'react';

import {Link} from 'react-router-dom';
import {Grid} from '@material-ui/core';

import error404 from '../../assets/errors/404-icon.png';
import urls from "../../utils/urls";
import './styles.scss';

export default class PageNotFound extends Component {

    render() {
        return (
            <Grid container alignItems={"center"} className={'page-not-found-section'}>
                <Grid item xs={12} sm={3} />
                <Grid item xs={12} sm={6}>
                    <img src={error404} className="responsive-img" alt="Pagina no encontrada" />
                    <p className="text-center error-no">
                        <span>ERROR 404</span>
                    </p>
                    <p className="text-center error-text">
                        No podemos encontrar lo que estás buscando.<br />
                        Puede que el enlace esté dañado o haya expirado. ¡Lo sentimos!
                    </p>
                    <p className="text-center error-text">
                        <Link to={urls.API_ROOT}>Inicio</Link>
                    </p>
                </Grid>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pageNotFound/PageNotFound.js